export function decodeToken(token) {
    try {
        const payload = JSON.parse(atob(token.split('.')[1]));

        return payload;
    } catch (error) {
        console.error('Error al decodificar el token:', error);
        return null; // Retornamos null en caso de error
    }
}